import { LeadType } from '../../api/models';
import {
  createAction,
  createActionWithPayload,
  IAction,
  IActionWithPayload,
} from '../utils';

const ACTION_LOAD_TYPE_REQUEST = 'ENTITIES/LOAD_TYPE_REQUEST';
const ACTION_LOAD_TYPE_SUCCESS = 'INTENT/LOAD_TYPE_SUCCESS';
const ACTION_LOAD_TYPE_ERROR = 'INTENT/LOAD_TYPE_ERROR';

export interface LeadTypeState {
  leadType: LeadType[];
  isLoading?: boolean;
  isLoaded?: boolean;
}

const initialState: LeadTypeState = {
  leadType: [],
  isLoaded: false,
  isLoading: false,
};

type LoadTypeRequestActionType = IAction<typeof ACTION_LOAD_TYPE_REQUEST>;

type LoadTypeSuccessActionType = IActionWithPayload<
  typeof ACTION_LOAD_TYPE_SUCCESS,
  LeadType[]
>;

type LoadTypeErrorActionType = IAction<typeof ACTION_LOAD_TYPE_ERROR>;

type Actions =
  | LoadTypeRequestActionType
  | LoadTypeSuccessActionType
  | LoadTypeErrorActionType;

export const loadTypeRequestAction = (): LoadTypeRequestActionType => {
  return createAction(ACTION_LOAD_TYPE_REQUEST);
};

export const loadTypeSuccessAction = (
  data: LeadType[]
): LoadTypeSuccessActionType => {
  return createActionWithPayload(ACTION_LOAD_TYPE_SUCCESS, data);
};

export const loadTypeErrorAction = (): LoadTypeErrorActionType => {
  return createAction(ACTION_LOAD_TYPE_ERROR);
};

// reducer
export const leadTypeReducer = (
  state: LeadTypeState = initialState,
  action: Actions
): LeadTypeState => {
  switch (action.type) {
    case ACTION_LOAD_TYPE_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    case ACTION_LOAD_TYPE_ERROR:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    case ACTION_LOAD_TYPE_SUCCESS:
      return {
        ...state,
        leadType: action.payload,
        isLoading: false,
        isLoaded: true,
      };
    default:
      return state;
  }
};
